var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "button-click-left" },
          [
            _c(
              "el-select",
              {
                staticClass: "button-left-class",
                attrs: { placeholder: "Chọn đại lý" },
                on: {
                  change: function ($event) {
                    return _vm.changeAgentMethod()
                  },
                },
                model: {
                  value: _vm.dataSearch.idAgent,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "idAgent", $$v)
                  },
                  expression: "dataSearch.idAgent",
                },
              },
              _vm._l(_vm.agentList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { value: item.id, label: item.agentName },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "button-left-class",
                staticStyle: { width: "200px" },
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "Chọn trường",
                },
                on: {
                  change: function ($event) {
                    return _vm.searchHeaderMethod()
                  },
                },
                model: {
                  value: _vm.dataSearch.idSchool,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "idSchool", $$v)
                  },
                  expression: "dataSearch.idSchool",
                },
              },
              _vm._l(_vm.schoolList, function (item) {
                return _c(
                  "el-option",
                  {
                    key: item.id,
                    attrs: {
                      value: item.id,
                      label: item.id + " - " + item.schoolName,
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.id))]),
                    _vm._v(" -\n          "),
                    _c("span", [_vm._v(_vm._s(item.schoolName))]),
                  ]
                )
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "button-left-small",
                attrs: { placeholder: "Chọn trạng thái" },
                on: {
                  change: function ($event) {
                    return _vm.handleDeleteStatus()
                  },
                },
                model: {
                  value: _vm.dataSearch.deleteStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "deleteStatus", $$v)
                  },
                  expression: "dataSearch.deleteStatus",
                },
              },
              _vm._l(_vm.deleteList, function (item) {
                return _c("el-option", {
                  key: item.key,
                  attrs: { value: item.key, label: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "button-left-small",
                attrs: { placeholder: "Chọn nhân sự" },
                on: {
                  change: function ($event) {
                    return _vm.searchHeaderMethod()
                  },
                },
                model: {
                  value: _vm.dataSearch.appType,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "appType", $$v)
                  },
                  expression: "dataSearch.appType",
                },
              },
              _vm._l(_vm.appTypeList, function (item) {
                return _c("el-option", {
                  key: item.key,
                  attrs: { value: item.key, label: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "button-left-small",
                attrs: { placeholder: "Trạng thái" },
                on: {
                  change: function ($event) {
                    return _vm.searchHeaderMethod()
                  },
                },
                model: {
                  value: _vm.dataSearch.statusEmployeee,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "statusEmployeee", $$v)
                  },
                  expression: "dataSearch.statusEmployeee",
                },
              },
              _vm._l(_vm.selectStatusEmployeeListOneAdmin, function (item) {
                return _c("el-option", {
                  key: item,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "el-input",
              {
                staticStyle: { width: "260px" },
                attrs: { placeholder: "Nhập tên hoặc SĐT", clearable: "" },
                on: {
                  clear: function ($event) {
                    return _vm.searchHeaderMethod()
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchHeaderMethod()
                  },
                },
                model: {
                  value: _vm.dataSearch.employeeNameOrPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "employeeNameOrPhone", $$v)
                  },
                  expression: "dataSearch.employeeNameOrPhone",
                },
              },
              [
                _c("el-button", {
                  attrs: { slot: "append", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.searchHeaderMethod()
                    },
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "button-click row-data" },
          [
            _c(
              "el-dropdown",
              { on: { command: _vm.handleCommand } },
              [
                _c(
                  "el-button",
                  { staticClass: "button-over", attrs: { type: "success" } },
                  [
                    _vm._v("\n          Tác vụ\n          "),
                    _c("i", { staticClass: "el-icon-caret-bottom" }),
                  ]
                ),
                _c(
                  "el-dropdown-menu",
                  { staticClass: "el-dropdown-menu-container" },
                  [
                    _c(
                      "el-dropdown-item",
                      { attrs: { command: "changePasswordCommand" } },
                      [_vm._v("Đổi mật khẩu\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "table-content row-data" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              attrs: {
                "empty-text": _vm.textTable,
                "element-loading-text": _vm.$tableLoading,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255, 0)",
                data: _vm.employeeDataList,
                "highlight-current-row": "",
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                "cell-style": _vm.tableRowStyle,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "selection",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "index",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  prop: "fullName",
                  "min-width": "170",
                  sortable: "",
                  label: "Họ tên",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "click-fullname",
                            on: {
                              click: function ($event) {
                                return _vm.clickFullName(
                                  scope.$index,
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.fullName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Trường", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.school.id) +
                              " - " +
                              _vm._s(scope.row.school.schoolName)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdDate",
                  label: "Thời gian tạo",
                  align: "center",
                  width: "135",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.createdDate)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Phòng ban", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.departmentEmployeeList,
                        function (item) {
                          return _c("el-span", { key: item.department.id }, [
                            _vm._v(
                              "- " + _vm._s(item.department.departmentName)
                            ),
                            _c("br"),
                          ])
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Lớp", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.exEmployeeClassList,
                        function (item) {
                          return _c("el-span", { key: item.maClass.id }, [
                            _vm._v(
                              "- " +
                                _vm._s(item.maClass.className) +
                                "\n            "
                            ),
                            item.master
                              ? _c("span", [_vm._v(" - CN")])
                              : _vm._e(),
                            _c("br"),
                          ])
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "SĐT",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "SĐT-SMS", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Đổi số điện thoại nhận SMS",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "click-in-row",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changePhoneSMSDialogMethod(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(scope.row.phoneSMS))])]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Tài khoản", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.username == ""
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "handle-account",
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.accountHanedleDialogMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("≪Xử lý≫")])]
                                ),
                              ],
                              1
                            )
                          : _c("span", [_vm._v(_vm._s(scope.row.username))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "password",
                  width: "120",
                  label: "Mật khẩu",
                  align: "center",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "Kích hoạt",
                    align: "center",
                    width: "110",
                    sortable: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: scope.row.activated
                                  ? "Hủy kích hoạt tài khoản"
                                  : "Kích hoạt tài khoản",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function ($event) {
                                    return _vm.activeOneMethod(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.activated,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "activated", $$v)
                                  },
                                  expression: "scope.row.activated",
                                },
                              }),
                            ],
                            1
                          ),
                          scope.row.login
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "Đang đăng nhập",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-check",
                                    staticStyle: {
                                      "margin-left": "10px",
                                      color: "#409eff",
                                    },
                                  }),
                                ]
                              )
                            : _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "Chưa đăng nhập",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-check",
                                    staticStyle: {
                                      "margin-left": "10px",
                                      color: "red",
                                    },
                                  }),
                                ]
                              ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("i", {
                    staticClass: "el-icon-success",
                    staticStyle: { color: "#78a5e7", "margin-left": "10px" },
                  }),
                ]
              ),
              _c("el-table-column", {
                attrs: { label: "SMS", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: scope.row.smsReceive
                                ? "Hủy kích hoạt SMS"
                                : "Kích hoạt SMS",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-checkbox", {
                              on: {
                                change: function ($event) {
                                  return _vm.activeOneSMSMethod(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.smsReceive,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "smsReceive", $$v)
                                },
                                expression: "scope.row.smsReceive",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "birthday",
                  sortable: "",
                  label: "Ngày sinh",
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDate")(scope.row.birthday))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "120", prop: "email", label: "Email" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  align: "center",
                  fixed: "right",
                  width: "260",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.dataSearch.deleteStatus
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { width: "85px" },
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteEmployeeMethod(scope.row)
                                  },
                                },
                              },
                              [_vm._v("Xóa")]
                            )
                          : _c(
                              "el-button",
                              {
                                staticStyle: { width: "85px" },
                                attrs: { size: "mini", type: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreEmployeeMethod(scope.row)
                                  },
                                },
                              },
                              [_vm._v("Khôi phục")]
                            ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.$index, scope.row)
                              },
                            },
                          },
                          [_vm._v("Sửa")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openEmployeeHistory(scope.row)
                              },
                            },
                          },
                          [_vm._v("Lịch sử")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "paging-click row-data" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.pageNumber,
              "page-sizes": _vm.$pageListDefaultNew,
              "page-size": _vm.maxPageItem,
              layout: _vm.$pageLayoutDefault,
              total: _vm.pageTotal,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("UpdateEmployee", {
        ref: "UpdateEmployee",
        attrs: { dialogVisible: _vm.showUpdateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseUpdateMethod()
          },
        },
      }),
      _c("EmployeeLifecycleDialog", {
        attrs: {
          dialogVisible: _vm.showEmployeeHistoryDialog,
          employee: _vm.historyEmployee,
          adminMode: true,
        },
        on: { "dialog-close": _vm.closeEmployeeHistory },
      }),
      _c("AccountHandle", {
        ref: "AccountHandle",
        attrs: { dialogVisible: _vm.showAccountHandeDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseAccountHandleMethod()
          },
        },
      }),
      _c("ChangePhoneSMS", {
        ref: "ChangePhoneSMS",
        attrs: { dialogVisible: _vm.showChangePhoneSMSDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseChangePhoneSMSMethod()
          },
        },
      }),
      _c("ChangePasswordMany", {
        ref: "ChangePasswordMany",
        attrs: { dialogVisible: _vm.showChangePasswordManyDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeChangePasswordManyDialog()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }